const TIMERS = {};

export default class TimersRegistry {
    static put(name, timer) {
        if (TimersRegistry.has(name)) {
            throw new Error(`Timer with the name "${name}" already exists in Timers Registry.`);
        }
        TIMERS[name] = timer;
    }

    static get(name) {
        return TIMERS[name];
    }

    static has(name) {
        return TIMERS[name] !== undefined;
    }

    static remove(name) {
        delete TIMERS[name];
    }

    static replace(name, timer) {
        TIMERS[name] = timer;
    }

    static clear() {
        Object.keys(TIMERS).forEach(key => {
            TimersRegistry.remove(key);
        });
    }
}
